import { useInjection } from 'inversify-react';
import type { NestedKeyOf, UIConfigResolver } from './UIConfigResolver';
import { TYPES } from '@/engine/ioc';
import type { UIConfigSchema } from './UIConfigSchema';
import type React from 'react';

export const useSurgerySpecificUiConfigValue = <R>(descriptor: NestedKeyOf<UIConfigSchema>, fallback?: R): R => {
  const uiConfigResolver = useInjection<UIConfigResolver>(TYPES.UIConfigResolver);
  if (uiConfigResolver.surgerySpecificConfigHasBeenSet()) {
    const value = uiConfigResolver.getOptionalValueByDescriptor<R>(descriptor);
    if (value !== undefined) {
      return value;
    }
  }
  if (fallback !== undefined) {
    return fallback;
  }
  throw new Error(`UI config value not found for descriptor: [${descriptor}], and no fallback was provided`);
};

export const useOptionalSurgerySpecificUiConfigValue = <R>(descriptor: NestedKeyOf<UIConfigSchema>): R | undefined => {
  const value = useSurgerySpecificUiConfigValue<R | null>(descriptor, null);
  if (value === null) {
    return undefined;
  }
  return value;
};

export const NullComponent: React.FC = () => {
  return null;
};
